// extracted by mini-css-extract-plugin
export default {"section_nav_item":"SectionNavItem_section_nav_item__+asOM","active":"SectionNavItem_active__os+VH","focus":"SectionNavItem_focus__wfiux"};